import type { ReferenceItem } from "../../api/types.js";
import { SourceCard } from "./SourceCard.js";

export function CitedSourcesTab({
  sources,
  selectedCitation,
  missingSelectedCitation,
  currentSessionId,
  saveSourceAsAsset
}: {
  sources: ReferenceItem[];
  selectedCitation: number | null;
  missingSelectedCitation?: boolean;
  currentSessionId?: string | null;
  saveSourceAsAsset: (source: ReferenceItem) => void | Promise<void>;
}) {
  if (missingSelectedCitation) {
    return <p className="empty-note source-empty" role="status">未找到这条引用对应的来源详情，请稍后重试或检查该消息的引用记录。</p>;
  }
  if (sources.length === 0) {
    return <p className="empty-note source-empty">当前还没有被本轮正文引用的来源。</p>;
  }

  return (
    <>
      {sources.map((source) => (
        <SourceCard
          key={`${source.poolId}-${source.citationIndex || source.index || ""}`}
          source={source}
          active={selectedCitation === (source.citationIndex || source.index)}
          citationIndex={source.citationIndex || source.index}
          currentSessionId={currentSessionId}
          showVerification={source.sourceType !== "web"}
          onSave={saveSourceAsAsset}
        />
      ))}
    </>
  );
}
